import React from 'react';

const toneMap = {
  blue: 'text-blue-500',
  cyan: 'text-cyan-500',
  emerald: 'text-emerald-500',
  green: 'text-emerald-500',
  amber: 'text-amber-500',
  yellow: 'text-amber-500',
  orange: 'text-orange-500',
  red: 'text-rose-500',
  rose: 'text-rose-500',
  purple: 'text-purple-500',
  indigo: 'text-indigo-500',
  slate: 'text-slate-400',
  gray: 'text-slate-400',
};

export const OperationalMetricItem = ({
  label,
  value,
  detail,
  icon: Icon,
  tone = 'blue',
  onClick,
  active = false,
  className = '',
}) => {
  const isEmoji = typeof Icon === 'string';
  const Element = onClick ? 'button' : 'div';

  return (
    <Element
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      aria-pressed={onClick ? active : undefined}
      className={`flex min-h-20 min-w-0 items-center gap-3 bg-white/80 px-4 py-3 text-left backdrop-blur-xl transition dark:bg-slate-900/75 ${onClick ? 'cursor-pointer hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500 dark:hover:bg-slate-800' : ''} ${active ? 'relative z-10 ring-2 ring-inset ring-primary-500' : ''} ${className}`}
    >
      <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-slate-100 dark:bg-slate-800 ${toneMap[tone] || toneMap.blue}`}>
        {isEmoji ? <span className="text-lg" aria-hidden="true">{Icon}</span> : Icon ? <Icon className="h-5 w-5" aria-hidden="true" /> : null}
      </div>
      <div className="min-w-0">
        <p className="text-xs font-semibold uppercase leading-tight tracking-wide text-slate-500 dark:text-slate-300">{label}</p>
        <div className="mt-0.5 flex flex-wrap items-baseline gap-x-3 gap-y-0.5">
          <p className="text-lg font-bold text-slate-900 dark:text-white">{value}</p>
          {detail && <p className="text-xs text-slate-500 dark:text-slate-400">{detail}</p>}
        </div>
      </div>
    </Element>
  );
};

const OperationalMetricStrip = ({ items = [], columns, className = '' }) => {
  const columnClass = columns || (
    items.length >= 5
      ? 'sm:grid-cols-2 xl:grid-cols-5'
      : items.length === 4
        ? 'sm:grid-cols-2 xl:grid-cols-4'
        : items.length === 3
          ? 'sm:grid-cols-3'
          : items.length === 2
            ? 'sm:grid-cols-2'
            : 'grid-cols-1'
  );

  return (
    <section className={`grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-slate-200/80 bg-slate-200/80 shadow-sm dark:border-slate-700/60 dark:bg-slate-700/60 ${columnClass} ${className}`}>
      {items.map((item, index) => (
        <OperationalMetricItem key={item.key || item.label || index} {...item} />
      ))}
    </section>
  );
};

export default OperationalMetricStrip;
